function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { NavigationContext, NavigationRouteContext } from '@react-navigation/native';
import * as React from 'react';
import { StyleSheet, View } from "react-native-web";
import { useSafeAreaFrame, useSafeAreaInsets } from 'react-native-safe-area-context';
import Background from "./Background";
import getDefaultHeaderHeight from "./Header/getDefaultHeaderHeight";
import HeaderHeightContext from "./Header/HeaderHeightContext";
import HeaderShownContext from "./Header/HeaderShownContext";
export default function Screen(props) {
  var dimensions = useSafeAreaFrame();
  var insets = useSafeAreaInsets();
  var isParentHeaderShown = React.useContext(HeaderShownContext);
  var parentHeaderHeight = React.useContext(HeaderHeightContext);
  var focused = props.focused,
    _props$modal = props.modal,
    modal = _props$modal === void 0 ? false : _props$modal,
    header = props.header,
    _props$headerShown = props.headerShown,
    headerShown = _props$headerShown === void 0 ? true : _props$headerShown,
    headerTransparent = props.headerTransparent,
    _props$headerStatusBa = props.headerStatusBarHeight,
    headerStatusBarHeight = _props$headerStatusBa === void 0 ? isParentHeaderShown ? 0 : insets.top : _props$headerStatusBa,
    navigation = props.navigation,
    route = props.route,
    children = props.children,
    style = props.style;
  var _React$useState = React.useState(function () {
      return getDefaultHeaderHeight(dimensions, modal, headerStatusBarHeight);
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    headerHeight = _React$useState2[0],
    setHeaderHeight = _React$useState2[1];
  return /*#__PURE__*/React.createElement(Background, {
    accessibilityElementsHidden: !focused,
    importantForAccessibility: focused ? 'auto' : 'no-hide-descendants',
    style: [styles.container, style]
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.content
  }, /*#__PURE__*/React.createElement(HeaderShownContext.Provider, {
    value: isParentHeaderShown || headerShown !== false
  }, /*#__PURE__*/React.createElement(HeaderHeightContext.Provider, {
    value: headerShown ? headerHeight : parentHeaderHeight !== null && parentHeaderHeight !== void 0 ? parentHeaderHeight : 0
  }, children))), headerShown ? /*#__PURE__*/React.createElement(NavigationContext.Provider, {
    value: navigation
  }, /*#__PURE__*/React.createElement(NavigationRouteContext.Provider, {
    value: route
  }, /*#__PURE__*/React.createElement(View, {
    onLayout: function onLayout(e) {
      var height = e.nativeEvent.layout.height;
      setHeaderHeight(height);
    },
    style: headerTransparent ? styles.absolute : null
  }, header))) : null);
}
var styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column-reverse'
  },
  // This is necessary to avoid applying 'column-reverse' to screen content
  content: {
    flex: 1
  },
  absolute: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0
  }
});